export class DataRowToValidateDTO{
    constructor(){
        this.ProdottoInfo,
        this.Quantita,
        this.CodiceDeposito
    }
}